import './Navigation.scss'

import { Container, Col, Row, Nav } from 'react-bootstrap'
import { useLocation, useHistory } from 'react-router-dom'

import { isInApp } from '../../helpers/Mobile'
import { navigateTo, menu } from '../index'

import {
  ROUTE_LOGIN,
  ROUTE_LOGOUT,
  ROUTE_SIGNUP,
  ROUTE_PAYMENTS,
  ROUTE_PAYMENTS_COMPLETE,
  ROUTE_PAYMENTS_DETAILS,
  ROUTE_VERIFY,
  ROUTE_WELCOME,
  ROUTE_ACTIVITIES_AFFIRMATIONS_BUILDER,
  ROUTE_DAILY_REMBLE_VIDEO,
  ROUTE_ACTIVITIES_BREATHING_INTRO,
  ROUTE_ACTIVITIES_BREATHING,
  ROUTE_ACTIVITIES_CUSTOM_MEDITATE,
  getSegment,
  ROUTE_LOGIN_PRIVATE,
  ROUTE_LOGIN_OAUTH,
  ROUTE_TOS_ACCEPTANCE,
  ROUTE_FORGOT_PASSWORD,
  ROUTE_ASSESSMENT,
  ROUTE_ASSESSMENT_COMPLETE,
  ROUTE_CHECK_IN,
  ROUTE_CHECK_IN_SUMMARY
} from '../../helpers/Paths'

/**
 * Simple Navigation component for bottom tab bar. See `Header.jsx` for Offcanvas navigation
 * @param {Object} paramObj Dependency object, uses `isAuthenticated` state variable to know if a user is logged in
 */
export default function Navigation({ isAuthenticated }) {
  const { pathname } = useLocation()
  const history = useHistory()

  const shouldHideNavigation = () => {
    // Hide nav on payments and on focus screens
    const focusScreens = [
      '/', // Hide on / webroot
      ROUTE_LOGIN,
      ROUTE_LOGIN_PRIVATE,
      ROUTE_LOGIN_OAUTH,
      ROUTE_LOGOUT,
      ROUTE_PAYMENTS,
      ROUTE_PAYMENTS_DETAILS,
      ROUTE_PAYMENTS_COMPLETE,
      ROUTE_SIGNUP,
      ROUTE_WELCOME,
      ROUTE_TOS_ACCEPTANCE,
      ROUTE_FORGOT_PASSWORD,
      ROUTE_VERIFY,
      ROUTE_ACTIVITIES_AFFIRMATIONS_BUILDER,
      ROUTE_DAILY_REMBLE_VIDEO,
      ROUTE_ACTIVITIES_BREATHING,
      ROUTE_ACTIVITIES_BREATHING_INTRO,
      ROUTE_ACTIVITIES_CUSTOM_MEDITATE,
      ROUTE_ASSESSMENT,
      ROUTE_ASSESSMENT_COMPLETE,
      ROUTE_CHECK_IN,
      ROUTE_CHECK_IN_SUMMARY
    ]
    const isFocusScreen = focusScreens.includes(pathname)

    const isActivityScreen =
      getSegment(3) === 'meditate' || getSegment(3) === 'breath'

    // Don't display tab bar on mobile app, if user is not authenticated,
    // or if user is on a "Focus" screen, or an activity screen
    return isInApp() || !isAuthenticated || isFocusScreen || isActivityScreen
  }

  if (shouldHideNavigation()) return null

  return (
    <nav className='navbar fixed-bottom' role='navigation'>
      <Nav className='w-100'>
        <Container className='p-0'>
          <Row className='d-flex w-100 m-0 nav-menu-container'>
            {menu().map(tab => (
              <Col
                key={tab.label}
                className='justify-content-center align-items-center text-center'
              >
                <Nav.Link
                  onClick={_ => navigateTo(tab.route, history)}
                  className={`${
                    pathname.indexOf(tab.route) > -1 ? 'active' : ''
                  }`}
                >
                  <span className='icon'>{tab.icon}</span>
                  <small className='label'>{tab.label}</small>
                </Nav.Link>
              </Col>
            ))}
          </Row>
        </Container>
      </Nav>
    </nav>
  )
}
